import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, PopoverController, ToastController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { PopupPage } from '../popup/popup';
import { CalendarPage } from '../calendar/calendar';

/**
 * Generated class for the ChoosedriverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-choosedriver',
  templateUrl: 'choosedriver.html',
})
export class ChoosedriverPage {
  obj: any
  seldriver: any
  radioDriver: any;
  vehicleid: any
  assigntime = ''
  futuredate: any;
  futuredateStr = '';
  futuredateYMD = '';
  futuretime = ''
  futuretf = false
  futuretfoverview = false
  delayedassignments = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public popoverCtrl: PopoverController, public toastCtrl: ToastController) {
    this.obj = this.navParams.get('obj');
    this.obj.unshift({ id: 0, clientid: this.gn.user.ClientId, fullname: this.gn.dic.l["NoneDriver"] })
    this.seldriver = this.navParams.get('seldriver');
    this.vehicleid = this.navParams.get('vid');
    this.assigntime = this.dic.l["now"]
    this.futuredateStr = moment().add(1, 'days').format(this.gn.user.DFormat)
    this.futuredateYMD = moment().add(1, 'days').format('YYYY-MM-DD')
    this.futuretime = '00:00'

    console.log(this.obj, 'this.obj')
    if (this.seldriver != '/' || undefined) {
      for (let i = 0; i < this.obj.length; i++) {
        if (this.seldriver + '' == this.obj[i].fullname + '') {
          this.radioDriver = this.obj[i].id
        }
      }
    }
    else {
      this.radioDriver = 0
    }
    this.resetSearch()

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChoosedriverPage');
    this.loadDelayedAssignments();
  }

  loadDelayedAssignments() {
    var _that = this
    _that.gn._Post('/api/gn/getdelayedassignments', { vid: _that.gn.crypt(_that.vehicleid) }, function (_dataD) {
      _that.delayedassignments = _dataD.delayedassignments
      for (var d = 0; d < _that.delayedassignments.length; d++) {
        _that.delayedassignments[d].datetime = moment(_that.delayedassignments[d].datetime).format(_that.gn.user.DFormat + ' HH:mm')
      }
      //debugger
    })
  }

  deleteDelayedAssignment(_id) {
    var _that = this
    const confirm = this.alertCtrl.create({
      title: this.dic.l["deleteDelayedAssignment"],
      message: this.dic.l["delayedAssignmentDelete"],
      buttons: [
        { text: this.dic.l["NO"] },
        {
          text: this.dic.l["YES"],
          handler: () => {
            var _dat = {
              id: this.gn.crypt(_id)
            }
            this.gn._Post('/api/gn/deleteDelayedAssignment', _dat, function (_data) {
              _that.loadDelayedAssignments()
            })
          }
        }
      ]
    });
    confirm.present();
  }

  openDatePopup(_ev, _startend) {
    this.futuredate = new Date()

    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: this.futuredate, cb: function (d) {
        _that.futuredate = d;
        _that.futuredateStr = moment(_that.futuredate).format(_that.gn.user.DFormat)
        _that.futuredateYMD = moment(_that.futuredate).format('YYYY-MM-DD')
      }
    })
    popover.present({ ev: _ev });
  }

  openTimePopup(se, _ev) {

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeassignment', selected: [], callback: function (_text, _ids) {
        _that.futuretime = _text
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text
        // if (se == 's') {
        //   _that.startTime = _text;
        // }
        // else {
        //   _that.endTime = _text;
        // }

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  openAssignDriver(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'assigndriver', selected: 0, callback: function (_text, _ids) {
        _that.assigntime = _text
      }
    });
    popover.present({ ev: _ev });
  }

  assignDriver() {
    if (!this.futuretf) {
      var cb = this.navParams.get('cb')
      var _that = this
      _that.gn._Post('/api/gn/setdrivervehicle', { vid: _that.gn.crypt(_that.vehicleid), did: _that.gn.crypt(_that.radioDriver) }, function (_data2) {
        _that.gn.tfBtn = true;
        if (_data2.msg == 'Busy') {

          var _mess = _data2.data[0].drivername + ' ' + _that.dic.l["alreadyAssign"] + ' ' + _data2.data[0].vehreg + ' (' + moment(_data2.data[0].startdate).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) + ')';

          let alert = _that.alertCtrl.create({
            title: _that.dic.l["assignDriver"],
            subTitle: _mess + '<br>' + _that.dic.l["areSureAssignDriver"] + ' ' + _that.gn.Vehicles[_that.gn.VehiclesDic[_that.vehicleid]].registration + ' (' + _that.gn.Vehicles[_that.gn.VehiclesDic[_that.vehicleid]].code + ')?',
            buttons: [
              {
                text: _that.dic.l['ok'],
                handler: data1 => {
                  _that.gn._Post('/api/gn/confirmreassign', { vid: _that.gn.crypt(_that.vehicleid), did: _that.gn.crypt(_that.radioDriver) }, function (_data2) {
                    for (var i = 0; i < _that.gn.Vehicles.length; i++) {
                      if (_that.gn.Vehicles[i].vehicleid + '' == _that.vehicleid + '') {
                        if (_that.radioDriver != '0') {
                          for (var j = 0; j < _that.obj.length; j++) {
                            if (_that.obj[j].id + '' == _that.radioDriver + '') {
                              // console.log(_that.obj[j].fullname, _that.gn.Vehicles[i].id, _that.gn.Vehicles[i].code)
                              _that.gn.Vehicles[i].driver = _that.obj[j].fullname
                              // console.log(_that.gn.Vehicles[i].driverdest, '_that.gn.Vehicles[i].driverdest')
                              _that.gn.Vehicles[i].driverdest = '/'
                            }
                          }
                        } else {
                          // debugger
                          // console.log(_that.gn.Vehicles[i].driverdest, '_that.gn.Vehicles[i].driverdest')

                          _that.gn.Vehicles[i].driver = '/'
                          _that.gn.Vehicles[i].driverdest = '/'
                        }
                      }
                    }
                    // debugger
                    // console.log('/', _data2.updatevid, _that.gn.Vehicles[_that.gn.VehiclesDic[_data2.updatevid]].code)
                    _that.gn.Vehicles[_that.gn.VehiclesDic[_data2.updatevid]].driver = '/'
                    _that.gn.Vehicles[_that.gn.VehiclesDic[_data2.updatevid]].driverdest = '/'
                  })
                }
              },
              {
                text: _that.dic.l['cancel'],
                role: 'cancel'
              }
            ]
          });
          alert.present();

          // const toast = _that.toastCtrl.create({
          //   message: _that.dic.l["DriverBusy"],
          //   duration: 3000,
          //   position: 'top'
          // });
          // toast.present();
        } else {
          for (var i = 0; i < _that.gn.Vehicles.length; i++) {
            if (_that.gn.Vehicles[i].vehicleid + '' == _that.vehicleid + '') {
              if (_that.radioDriver != '0') {
                for (var j = 0; j < _that.obj.length; j++) {
                  if (_that.obj[j].id + '' == _that.radioDriver + '') {
                    _that.gn.Vehicles[i].driver = _that.obj[j].fullname
                    // debugger
                    _that.gn.Vehicles[i].driverdest = '/'
                  }
                }
              } else {
                _that.gn.Vehicles[i].driver = '/'
                // debugger
                _that.gn.Vehicles[i].driverdest = '/'
              }
            }
          }
        }
        _that.gn.tfBtn = false;
        _that.navCtrl.pop()
        cb(_that.radioDriver)
      });
    } else {
      var _that = this
      if (_that.radioDriver + '' == '0') {
        const toast = _that.toastCtrl.create({
          message: _that.dic.l["choosedriverdelayed"],
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
        _that.gn._Post('/api/gn/setdrivervehiclefuture', { cid: _that.gn.crypt(_that.gn.user.ClientId), vid: _that.gn.crypt(_that.vehicleid), did: _that.gn.crypt(_that.radioDriver), dtfuture: _that.gn.crypt(_that.futuredateYMD + ' ' + _that.futuretime) }, function (_dataD) {
          const toast = _that.toastCtrl.create({
            message: _that.dic.l["delayedassignment"] + ' ' + _dataD.driverFullname + ' ' + _that.dic.l["ofvehicle"] + ' ' + _that.gn.Vehicles[_that.gn.VehiclesDic[_that.vehicleid]].registration + ' (' + _that.gn.Vehicles[_that.gn.VehiclesDic[_that.vehicleid]].code + ') ' + _that.dic.l["for"] + ' ' + _that.futuredateStr + ' ' + _that.futuretime + ' ' + _that.dic.l["succsaved"] + '.',
            duration: 6000,
            position: 'top'
          });
          toast.present();
          _that.navCtrl.pop()
        })
      }
    }
  }

  resetSearch() {
    for (var i = 0; i < this.obj.length; i++) {
      this.obj[i].Visible = true
    }
  }

  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchClients(val);
  }


  searchClients(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.obj.length; i++) {
        if (this.gn._latcyr(this.obj[i].fullname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.obj[i].fullname.toLowerCase()).indexOf(val) > -1) {
          this.obj[i].Visible = true
        } else {
          this.obj[i].Visible = false
        }
      }
    }
    else {
      this.resetSearch()
    }
  }

  ionViewDidLeave() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/choosedriver/choosedriver.ts